import React from 'react';
import PropTypes from 'prop-types';
import ImageGallery from 'react-image-gallery';

export const GridGallery = ({ images }) => {
  return <ImageGallery items={images} />;
};

const { array } = PropTypes;

GridGallery.propTypes = {
  images: array,
};

export default GridGallery;